import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface LoadingStateProps {
  type: 'table' | 'card' | 'form';
  count?: number;
}

const LoadingState: React.FC<LoadingStateProps> = ({ type, count = 3 }) => {
  const renderTableLoading = () => (
    <div className="space-y-4">
      <Skeleton height={50} />
      {Array(count).fill(0).map((_, i) => (
        <Skeleton key={i} height={40} />
      ))}
    </div>
  );

  const renderCardLoading = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {Array(count).fill(0).map((_, i) => (
        <div key={i} className="bg-white p-6 rounded-xl shadow-sm">
          <Skeleton height={24} width={100} className="mb-4" />
          <Skeleton height={36} />
        </div>
      ))}
    </div>
  );

  const renderFormLoading = () => (
    <div className="space-y-6">
      <Skeleton height={40} className="mb-4" />
      <Skeleton height={40} className="mb-4" />
      <Skeleton height={100} className="mb-4" />
      <Skeleton height={40} width={100} />
    </div>
  );

  switch (type) {
    case 'table':
      return renderTableLoading();
    case 'card':
      return renderCardLoading();
    case 'form':
      return renderFormLoading();
    default:
      return null;
  }
};

export default LoadingState;